import React, { useState } from "react";
import Navbar, { ProfileNavbar, Navtopbar } from "./Navbar";
import Sidebar from "./Sidebar";
import { GeneralSettings } from "./GenerlSettings";
import AppointmentSettings from "./AppointmentSettings";
import { useNavigate } from "react-router-dom";
const Setting = () => {
  const [activeTab, setActiveTab] = useState("general");

  // Function to toggle active tab
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  const navigate = useNavigate();

  return (
    <div className="dashboard-container">
      <Sidebar />
      <div className="dashboard-content">
        <Navtopbar
          onClick={() => {
            navigate("/profile");
          }}
          title="Settings"
        />

        <div
          className="dashboard-cards"
          style={{ paddingLeft: 30, paddingRight: 30, flexDirection: "column" }}
        >
          {/* <div className="flex-row" style={{ marginBottom: 20 }}>
            <div
              className={
                activeTab === "general"
                  ? "General_Settings"
                  : "Clinical_Settings"
              }
              onClick={() => handleTabClick("general")}
            >
              General Settings
            </div>
            <div
              className={
                activeTab === "appointment"
                  ? "General_Settings"
                  : "Clinical_Settings"
              }
              onClick={() => handleTabClick("appointment")}
            >
              Appointment Settings
            </div>
          </div> */}
          <div className="section-box">
            <h2 style={{ textAlign: "left" }}>Provider Settings</h2>
            <div className="tab-bar">
              <button
                className={`tab-button_two ${
                  activeTab === "general" ? "active" : ""
                }`}
                onClick={() => handleTabClick("general")}
              >
                <i className="fas fa-cog" />
                General Settings
              </button>
              <button
                className={`tab-button_two ${
                  activeTab === "appointment" ? "active" : ""
                }`}
                onClick={() => handleTabClick("appointment")}
              >
                {" "}
                <i className="fas fa-calendar-check" />
                Appointment Settings
              </button>
            </div>
          </div>

          <div
            className="dashboard-cards"
            style={{
              padding: 30,
              paddingTop: 50,
              flexDirection: "column",
              paddingBottom: 0,
            }}
          >
            {activeTab === "general" && <GeneralSettings />}
            {activeTab === "appointment" && <AppointmentSettings />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Setting;
